export enum ReportEnum {
  SaleReport = 'SaleReport',
  OrderReport = 'OrderReport',
  PaymentReport = 'PaymentReport',
  DriverReport = 'DriverReport',
  PartiallyCompleted="PartiallyCompleted"
}
